import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Confirm from "../Confirm";
import { useLocation, useNavigate, Link } from "react-router-dom";
import trasportApi from "../../api/trasportApi";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { BsChevronRight } from "react-icons/bs";
import PubSub from "pubsub-js";


const TrasporterView = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [trasportData, settrasportDataData] = useState(location.state ? location.state : {});
  const [modalShow, setModalShow] = useState(false);

  console.log("location.state",location.state)
  const isdelete = async () => {
    let result = await trasportApi.deleteTransporters(trasportData.id);
    if (result.success){
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record deleted successfully' });
        navigate(`/transporters`);
    } 
  };

  const edittrasportData = () => {
    navigate(`/transporters/${trasportData.id}/e`, { state: trasportData });
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>
             {`${trasportData.transporter_name}`} 
          </title>
        </Helmet>
      </>
      <div>
        {trasportData && (
          <Container>
            {modalShow && (
              <Confirm
              show={modalShow}
              onHide={() => setModalShow(false)}
              isdelete={isdelete}
              title="Confirm delete?"
              message="You are going to delete the record. Are you sure?"
              table="transporter"
            />
            )}

        
            <Col lg={2} className="mx-2">
              <Link to="/home" style={{ "text-decoration": "none" }}>
                Home
              </Link>{" "}
              {/* <i className="fa-solid fa-chevron-right"></i> */}
              <BsChevronRight/>
              <Link to="/transporters" style={{ "text-decoration": "none" }}>
              Transporter
              </Link>
            </Col>
            <Row className="view-form">
              <Col></Col>
              <Col lg={8}>
                <Row className="view-form-header align-items-center">
                  <Col lg={4}>
                    {/* <div>trasportData Id: {trasportData.contactno}</div> */}
                    <h5>
                      {trasportData.trasportData_name}{" "}
                    </h5>
                  </Col>
                  <Col lg={8} className="d-flex justify-content-end">
                      <Button
                        className="btn-sm mx-2"
                        onClick={() => edittrasportData(true)}
                        >
                      <i className="fa-regular fa-pen-to-square"></i>
                    </Button>
                    <Button
                      className="btn-sm"
                      variant="danger"
                      onClick={() => setModalShow(true)}
                    >
                      Delete
                    </Button>
                  </Col>
                </Row>
                <Row>
                <Col lg={6}>
                    <label>Financial Year</label>
                    <span>{trasportData.financial_year_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Contact Person</label>
                    <span>{trasportData.contact_person }</span>
                  </Col>
                  <Col lg={6}>
                    <label>Phone</label>
                    <span>{trasportData.phone}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Email</label>
                    <span>{trasportData.email}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Address</label>
                    <span>{trasportData.address}</span>
                  </Col>
                  
                  <Col lg={6}>
                    <label>City</label>
                    <span>{trasportData.city}</span>
                  </Col>
                 
                  <Col lg={6}>
                    <label>District</label>
                    <span>{trasportData.district}</span>
                  </Col>
                  <Col lg={6}>
                    <label>State</label>
                    <span>{trasportData.state}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Country</label>
                    <span>{trasportData.country}</span>
                  </Col>
              
                  <Col lg={6}>
                    <label>Pincode</label> 
                    <span>{trasportData.pincode}</span>
                  </Col>
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        Bank Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Bank Name</label> 
                    <span>{trasportData.bank_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Bank Branch Name</label> 
                    <span>{trasportData.bank_branch_name}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Bank Account Number</label> 
                    <span>{trasportData.bank_account_number}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Ifsc Code</label> 
                    <span>{trasportData.ifsc_code}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Micr</label> 
                    <span>{trasportData.micr}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Rtgs Details</label> 
                    <span>{trasportData.rtgs_details}</span>
                  </Col>
                  <Col lg={12}>
                    <Col className="section-header my-3">
                      <span style={{ color: "blue", paddingLeft: "10px" }}>
                        User Information
                      </span>
                    </Col>
                  </Col>
                  <Col lg={6}>
                    <label>Created By</label> 
                    <span>{trasportData.createdbyname}</span>
                  </Col>
                  <Col lg={6}>
                    <label>Lastmodified By</label> 
                    <span>{trasportData.lastmodifiedbyname}</span>
                  </Col>
                </Row>
              </Col>
              
              <Col></Col>
             
            </Row>
          </Container>
        )}
      </div>
    </Main>
  );
};
export default TrasporterView;
